import { useEffect, useState } from 'react';
import AutoSuggestContainer from './AutoSuggestContainer';
import { AutoSuggestProps, AutoSuggestOption } from './types';

// eslint-disable-next-line
const AutoSuggest = <T extends unknown>(
    props: AutoSuggestProps<T>) => {
    const {
        name,
        getOptions,
        label,
        onSelectedOption,
        selectedOption,
        inlineHelp,
        placeholder,
    } = props;

    const [options, setOptions] = useState<AutoSuggestOption<T>[]>([]);
    const [searchTerm, setSearchTerm] = useState(selectedOption || '');
    const [noResult, setNoResult] = useState(false);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onSearchTermChanged = async (term: string) => {
        setIsLoading(true);
        setNoResult(false);
        setSearchTerm(term);
        if (term.length > 2) {
            const opt = await getOptions(term);
            setOptions(opt);
            if (opt.length === 0) {
                setNoResult(true);
            }
        } else {
            setOptions([]);
        }
        if (term.length === 0) {
            onSelectedOption();
        }
        setIsLoading(false);
    };

    const onSelectionMade = async (option: AutoSuggestOption<T>) => {
        setIsLoading(true);
        await onSelectedOption(option);
        setIsLoading(false);
    };

    useEffect(() => {
        let mounted = true;
        if (mounted && selectedOption && selectedOption !== '') {
            setSearchTerm(selectedOption);
        }
        return (() => { mounted = false; });
    }, [selectedOption]);

    const onCancel = () => {
        setOptions([]);
        setIsLoading(false);
        setError(false);
        setNoResult(false);
        setSearchTerm(selectedOption || '');
    };

    return (
        <AutoSuggestContainer
            name={name}
            label={label}
            options={options}
            searchTerm={searchTerm}
            noResult={noResult}
            error={error}
            loading={isLoading}
            onCancel={onCancel}
            onSearchTermChange={onSearchTermChanged}
            onSelectedOption={onSelectionMade}
            inlineHelp={inlineHelp}
            placeholder={placeholder}
        />
    );
};

export default AutoSuggest;
